import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Institution } from '@app/shared/types/Institutions.types';

@Injectable({
  providedIn: 'root',
})
export class InstitutionsService {
  constructor(private httpClient: HttpClient) {}

getInstitutionsNew(
  offset: number,
  limit: number,
  nameFilter: string = '',
  parentFilter: string = '',
  vendorFilter:string = '',
  typeFilter: string = '',
  sortBy: string = 'name',
  sortDirection: 'asc' | 'desc' = 'asc',

): Observable<{ institutions: Institution[]; totalCount: number }> {
  
 
  const url = `${environment.apiUrl}/rest/ElabCases/getInstitutionsNew?` + 
              `limit=${limit}` +
              `&offset=${offset}` +
              `&sortBy=${sortBy}` +
              `&sortDirection=${sortDirection}` +
              `&nameFilter=${encodeURIComponent(nameFilter)}` +
              `&parentFilter=${encodeURIComponent(parentFilter)}` + 
              `&typeFilter=${encodeURIComponent(typeFilter)}` +
              `&vendorFilter=${encodeURIComponent(vendorFilter)}` 
              
  return this.httpClient.get<{
    institutions: Institution[];
    totalCount: number;
  }>(url);
}
}